
import { defineComponent, watchEffect } from 'vue'
import { ElConfigProvider } from 'element-plus'
import { useStore } from '@/store'
import { getAppTitle } from '@/utils/app-title'

import zhCn from 'element-plus/lib/locale/lang/zh-cn'
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default defineComponent({
  name: 'App',
  components: {
    ElConfigProvider
  },
  setup() {
    const store = useStore()

    watchEffect(() => {
      document.title = getAppTitle(
        store.state.login.userInfo.empNo,
        '运营辅助平台'
      )
    })

    return {
      locale: zhCn,
      aLocale: zh_CN
    }
  }
})
